import * as React from 'react';
import { observer } from 'mobx-react';

import { DropdownView } from 'src/core/ui/dropdown.view';

interface EmailTargetEditorViewProps {
	label?: string;
	value: number;
	onChanged: (value: number | null) => void;
	mode: ControlMode;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

@observer
export class EmailTargetEditorView extends React.Component<EmailTargetEditorViewProps, {}> {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<DropdownView
				label={this.props.label === undefined ? 'Email target' : this.props.label}
				onGetErrorMessage={this.props.onGetErrorMessage}
				model={this.props.value}
				required={this.props.required}
				disabled={this.props.mode == 'display'}
				onChanged={(newValue) => {
					this.props.onChanged(newValue.value);
				}}
				options={
					[
						{ value: 0, label: 'Agents' },
						{ value: 1, label: 'Clients' },
						{ value: 2, label: 'Suppliers' },
					]
				}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/email-document-template/parts/email-target-editor.view.tsx